export const    HELP_TILES = 'HELP_TILES';
export const    HELP_TILES_SUCCESS = 'HELP_TILES_SUCCESS';
export const    HELP_TILES_ERROR = 'HELP_TILES_ERROR';

export const    ADD_HELP_TILES = 'ADD_HELP_TILES';
export const    ADD_HELP_TILES_SUCCESS = 'ADD_HELP_TILES_SUCCESS';
export const    ADD_HELP_TILES_ERROR = 'ADD_HELP_TILES_ERROR';

export const    UPD_HELP_TILES = 'UPD_HELP_TILES';
export const    UPD_HELP_TILES_SUCCESS = 'UPD_HELP_TILES_SUCCESS';
export const    UPD_HELP_TILES_ERROR = 'UPD_HELP_TILES_ERROR';

export const    DEL_HELP_TILES = 'DEL_HELP_TILES';
export const    DEL_HELP_TILES_SUCCESS = 'DEL_HELP_TILES_SUCCESS';
export const    DEL_HELP_TILES_ERROR = 'DEL_HELP_TILES_ERROR';